<template>
  <sys-data-table
    v-model="ITEMS_SELECIONADOS"
    v-bind="$props"
    :headers="headers"
    :items="linhas"
    :loading="esta_carregando_dados"
    content-class="sys-data-table-blue-hover-linha text-black"
    :show-column-custom="showColumnCustom"
    :id-unique-preference="idUniquePreference"
    :disabled-columns-custom="disabledColumnsCustom"
    :item-class="classesCssLinha"
    :hide-border-bottom-tr="hideBorderBottomTr"
    :desativar_ordenacao="desativar_ordenacao"
    @scroll-items="ev => $emit('scroll-items', ev)"
    @click:row="ev => $emit('click:row', ev)"
    @dblclickRow:row="ev => $emit('dblclickRow:row', ev)"
    @contextmenu:column="ev => ev_contextmenu_column = ev"
    @ordernar-coluna-selecionada="ev => $emit('ordernar-coluna-selecionada', ev)"
    @click:th="ev =>  $emit('click:th', ev)"
  >
    <template #[`item.${PRIMEIRO_HEADER.value}`]="{item}">
      <div class="d-flex align-center ml-n1">
        <slot name="item.indentacao" :item="item">
          <div
            v-if="item.$nivel_linha && !item.$desabilitar_indentacao"
            :style="{width: `${item.$nivel_linha * 30}px`, height: `${itemHeight}px`}"
            style="border-right: 1px solid #cce0ff"
            class="bg-white mr-1"
          />
        </slot>

        <div v-if="!item.$nao_expansivel">
          <v-progress-circular
            v-if="esta_carregando_dados && item === ultima_linha_clicada"
            indeterminate
            color="red"
            size="15"
            width="1.3"
            class="mx-1"
          />

          <template v-else>
            <slot name="item.icon-expandir-recolher" :item="item">
              <div
                v-if="item.$nivel_linha < NIVEL_MAXIMO_LINHAS"
                :title="title_icon_expand"
                :class="{'cursor-pointer': !esta_carregando_dados, 'cursor-no-drop': esta_carregando_dados}"
                @click="expandirOuRecolherLinha(item)"
              >
                <v-icon :size="arrowIconSize" class="mr-1" v-if="linhas_expandidas.includes(item)">{{ arrowDownIcon }}</v-icon>
                <v-icon :size="arrowIconSize" class="mr-1" v-else>{{ arrowRightIcon}}</v-icon>
              </div>
            </slot>
          </template>
        </div>

        <div :class="{'ml-1': item.$nao_expansivel}" class="text-left">
          <slot :name="`_item.${PRIMEIRO_HEADER.value}`" :item="item">
            <v-icon
              v-if="item.left_icone"
              :size="arrowIconSize"
              class="mr-1 mb-1"
              color="#68686E"
            >
              {{ item.left_icone }}
            </v-icon>

            <span v-text="item[PRIMEIRO_HEADER.value]" />
          </slot>
        </div>
      </div>
    </template>

    <template #top>
      <OrdenacaoNivelMenu
        :ev_contextmenu_column="ev_contextmenu_column"
        :headers="headers"
        @ordenacao="ordenarNivel"
      />
    </template>

    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </sys-data-table>
</template>

<script>
import props from '@/components/utils/dataTable/sysDataTable/IndexProps'
import {logout} from "@/helpers";
import OrdenacaoNivelMenu from "@/components/utils/dataTable/sysDataTableExpand/OrdenacaoNivelMenu.vue";
import THeader from "@/components/utils/dataTable/sysDataTable/THeader.vue";

const QTDE_PARA_EXCLUIR = 0;

export default {
  name: "SysDataTableExpand",
  components: {
    THeader,
    OrdenacaoNivelMenu
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    ...props,
    callbacks: {
      type: Array,
      required: true
    },
    hideBorderBottomTr: {
      type: Boolean,
      default: true
    },
    desativar_ordenacao: {
      type: Boolean,
      default: true
    },
    arrowDownIcon: {
      type: String,
      default: "mdi-chevron-down",
      required: false
    },
    arrowRightIcon: {
      type: String,
      default: "mdi-chevron-right",
      required: false
    },
    arrowIconSize: {
      type: [String, Number],
      default: 23,
      required: false
    },
    title_icon_expand: String,
  },
  data: () => ({
    linhas_expandidas: [],
    ultima_linha_clicada: null,
    linhas: [],
    esta_carregando_dados: false,
    ev_contextmenu_column: {}
  }),
  computed: {
    ITEMS_SELECIONADOS: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    NIVEL_MAXIMO_LINHAS() {
      return this.callbacks.length - 1;
    },
    PRIMEIRO_HEADER() {
      return this.headers[0] || {};
    }
  },
  created() {
    this.$emit('callback-resetar-grid', this.resetarDadosGrid);
  },
  mounted() {
    this.resetarDadosGrid();
  },
  methods: {
    resetarDadosGrid() {
      let interval = setInterval(() => {
        if (this.esta_carregando_dados) return;

        this.linhas = [];
        this.executarCallback(this.callbacks[0]);
        clearInterval(interval)
      }, 500);
    },
    executarCallback(callback) {
      this.esta_carregando_dados = true;

      const idx_callback = this.callbacks.indexOf(callback);
      const idx_inicial_novas_linha = this.linhas.indexOf(this.ultima_linha_clicada) + 1;

      const callback_sucesso = linhas => {
        if (!linhas || !Array.isArray(linhas)) return;
        const novas_linhas = this.formatarLinhas(linhas, idx_callback);
        this.linhas.splice((idx_inicial_novas_linha || 0), QTDE_PARA_EXCLUIR, ...novas_linhas);
      };

      const callback_fim = () => {
        this.esta_carregando_dados = false;
        this.$emit('callback-executada', { callback: this.callback, idx_callback, linhas: this.linhas });
      };

      callback(this.ultima_linha_clicada)
        .then(callback_sucesso)
        .catch(logout)
        .finally(callback_fim)
    },
    formatarLinhas(linhas, nivel) {
      const callback = linha => {
        if (linha.$nivel_linha !== undefined) {
          return linha;
        }

        linha.$nivel_linha = nivel;
        return linha;
      };
      return linhas.map(callback);
    },
    expandirOuRecolherLinha(linha) {
      if (this.esta_carregando_dados || linha.$nivel_linha === this.NIVEL_MAXIMO_LINHAS) return;

      this.ultima_linha_clicada = linha;

      if (this.linhas_expandidas.includes(linha)) {
        this.$emit('recolher', linha);
        this.recolherLinha(linha);
      } else {
        this.expandirLinha(linha);
      }
    },
    expandirLinha(linha) {
      this.linhas_expandidas.push(linha);
      this.executarCallback(this.callbacks[linha.$nivel_linha + 1]);
    },
    recolherLinha(linha) {
      this.removerLinhasNivelRecolhido(linha);
      this.linhas_expandidas = this.linhas_expandidas.filter(item => item !== linha);
    },
    removerLinhasNivelRecolhido(linha) {
      const index_linha_clicada = this.linhas.indexOf(linha);

      const callback = (item, index) => (index > index_linha_clicada && item.$nivel_linha <= linha.$nivel_linha);
      let index_proximo_nivel_maior = this.linhas.findIndex(callback);

      if (index_proximo_nivel_maior === -1) {
        index_proximo_nivel_maior = this.linhas.length;
      }

      const inicio_da_exclusao = (index_linha_clicada + 1);
      const qtde_para_excluir = (index_proximo_nivel_maior - index_linha_clicada - 1);
      this.linhas.splice(inicio_da_exclusao, qtde_para_excluir);
    },
    classesCssLinha(linha) {
      let classes = {
        'sys-data-table-blue-linha-ativa': this.linhas_expandidas.includes(linha),
        'font-weight-bold-grid-expanded': this.linhas_expandidas.includes(linha) && (linha.$nivel_linha % 2) === 0
      };

      if (typeof this.itemClass === 'function') {
        classes = {...classes, ...this.itemClass(linha)};
      } else {
        classes[this.itemClass] = true;
      }

      return classes;
    },
    ordenarNivel({coluna, ordem, nivel_linha}) {

    }
  }
}
</script>

<style scoped>
</style>
